export default __webpack_public_path__ + "static/media/Screenshot_3.218aa2ca.webp";